import { useAuth } from '../lib/auth-context';

/**
 * Bottom-left version label (OCP-223) — renders the package.json
 * version baked at build time via Vite `define`.
 *
 * OCP-334 — only shown on the auth pages (login / forgot-password),
 * which have no sidebar. Inside the authenticated shell the version is
 * pinned to the bottom of the sidebar nav column (see Sidebar's
 * VersionFooter), so the floating overlay would be redundant + looked
 * unpolished. The "verify the live release without curling" purpose is
 * preserved on the login screen.
 *
 * Click-to-select for easy copy. Fixed-position, low z-index, never
 * blocks interactive UI.
 */
export function AppVersionBadge() {
  const { status } = useAuth();
  // Authenticated (or still resolving) → the sidebar owns the version.
  if (status !== 'unauthenticated') return null;
  return (
    <div
      className="pointer-events-auto fixed bottom-2 left-2 z-10 select-text font-mono text-xs text-gray-400"
      title="App version (deployed build)"
      data-testid="app-version-badge"
    >
      v{__APP_VERSION__}
    </div>
  );
}
